import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: null, services: [], hoursText: "", reload: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const [hoursText, setHoursText] = useState("");

  const reload = useCallback(async () => {
    try {
      const [s, sv, h] = await Promise.all([api.get("/settings"), api.get("/services"), api.get("/planning/hours")]);
      setSettings(s.data);
      setServices(sv.data);
      setHoursText(h.data.text);
    } catch (e) {
      console.error("settings load", e);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <SettingsContext.Provider value={{ settings, services, hoursText, reload }}>{children}</SettingsContext.Provider>
  );
};

export const useSite = () => useContext(SettingsContext);
